export default "__VITE_ASSET__4efe795c__"